import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function PageHeader() {
  return <section id="page-header" className="relative flex min-h-[45vh] items-center overflow-hidden bg-gradient-to-b from-[#1A3A52] to-[#0F2438] py-16 text-white md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 items-center">
          <div className="flex flex-col items-start space-y-6">
            <div className="space-y-4">
              <Breadcrumb>
                <BreadcrumbList className="text-primary/80 sm:gap-2.5">
                  <BreadcrumbItem>
                    <BreadcrumbLink asChild className="hover:text-primary transition-colors">
                      <Link to="/">Home</Link>
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator className="text-primary/60" />
                  <BreadcrumbItem>
                    <BreadcrumbLink asChild className="hover:text-primary transition-colors">
                      <Link to="#">Industries</Link>
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator className="text-primary/60" />
                  <BreadcrumbItem>
                    <BreadcrumbPage className="text-primary font-medium">
                      Electrical Contractors
                    </BreadcrumbPage>
                  </BreadcrumbItem>
                </BreadcrumbList>
              </Breadcrumb>

              <span className="inline-block text-sm font-semibold uppercase tracking-wider text-primary">
                For Electrical Contractors
              </span>

              <h1 className="font-default text-4xl font-bold leading-tight tracking-tight text-white md:text-5xl lg:text-6xl">
                Industrial Labeling for Electrical Contractors
              </h1>

              <p className="max-w-2xl text-lg leading-relaxed text-gray-200 md:text-xl">
                Evermark Industrial Solutions produces the engraved legend plates, panel nameplates, panel schedules, and arc flash labels electrical contractors need — quoted fast, proofed before production, and shipped on a timeline that holds up to an inspection date. Upload a file or a panel layout and get a quote.
              </p>
            </div>

            <div className="flex flex-col w-full sm:flex-row sm:w-auto gap-4 pt-2">
              <Button asChild size="lg" className="w-full sm:w-auto text-base">
                <Link to="#">Request a Quote</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-primary bg-transparent text-primary hover:bg-primary hover:text-primary-foreground text-base">
                
              </Button>
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-xl lg:max-w-none">
            <div className="relative aspect-[4/3] overflow-hidden rounded-lg shadow-2xl lg:aspect-auto lg:h-[500px]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/electrical_contractor_panel_labeling.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/electrical_contractor_panel_labeling.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/electrical_contractor_panel_labeling.webp-wvc-sizes" alt="Industrial labeling for electrical contractors — engraved control panel legend plates by Evermark Industrial Solutions" className="h-full w-full object-cover object-center" loading="eager" decoding="sync" />
              {}
              <div className="absolute inset-0 rounded-lg ring-1 ring-inset ring-white/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}